import { render, staticRenderFns } from "./ShockWaveReflectionViz.vue?vue&type=template&id=34657ba4&scoped=true"
import script from "./ShockWaveReflectionViz.vue?vue&type=script&lang=js"
export * from "./ShockWaveReflectionViz.vue?vue&type=script&lang=js"
import style0 from "./ShockWaveReflectionViz.vue?vue&type=style&index=0&id=34657ba4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34657ba4",
  null
  
)

export default component.exports